import React, { useContext, useState } from 'react';
import '../Questions/styles/SingleOption.scss';
import { layoutContext } from '../RAIAssessment';
import { useEffect } from 'react';

interface singleOptionProps {
  question: any;
}

const SingleOption = (singleOptionProps: singleOptionProps) => {
  const { question } = singleOptionProps;
  const { options } = question;
  const {
    setSelectedOption,
    answers,
    setAnswers,
    questionId,
    setSelectedItems,
    selectedItems,
  } = useContext(layoutContext);

  const [selectedRadio, setSelectedRadio] = useState(-1);

  useEffect(() => {
    const index = question.id as keyof typeof answers;
    if (answers[index] || answers[index] === 0) {
      setSelectedRadio(answers[index]);
    }
  }, [questionId]);

  const handleOptionChange = (item: any, index: number) => {
    setSelectedItems({
      ...selectedItems,
      [questionId]: item,
    }),
      setSelectedRadio(index);
    setSelectedOption(item);
    setAnswers({ ...answers, [question.id]: index });
  };

  return (
    <>
      {options.map((option: any, i: number) => {
        return (
          <label
            key={option.optionId}
            className={`rai-assessment__single-option ${
              selectedRadio === i
                ? 'rai-assessment__single-option-selected'
                : ''
            }`}
          >
            <span className="rai-assessment__single-option-text">
              {option.copy}
            </span>
            <input
              type="radio"
              name="options"
              checked={answers[question.id as keyof typeof answers] === i}
              onChange={() => handleOptionChange(option, i)}
              className="rai-assessment__single-option-input"
            />
          </label>
        );
      })}
    </>
  );
};

export default SingleOption;
